<template lang="pug">
base-dialog(
  :value="value",
  @input="$emit('input', $event)",
  :titulo="titulo",
  :max-width="maxWidth",
  :persistent="persistent",
  :mostrar-fechar="false",
  :texto-cancelar="textoCancelar",
  :texto-confirmar="textoConfirmar",
  @confirmar="$emit('confirmar')"
)
  .dialog-mensagem {{ mensagem }}
</template>

<script>
import BaseDialog from "./BaseDialog";

export default {
  name: "ConfirmacaoDialog",

  components: {
    BaseDialog
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: "Alerta"
    },
    mensagem: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: [String, Number],
      default: 400
    },
    persistent: {
      type: Boolean,
      default: true
    },
    textoCancelar: {
      type: String,
      default: "Cancelar"
    },
    textoConfirmar: {
      type: String,
      default: "Continuar"
    }
  }
};
</script>

<style scoped>
.dialog-mensagem {
  font-size: 13px;
  color: #2c3e50;
  line-height: 1.5;
}
</style>
